/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";
import { User, UserFromJSON, UserFromJSONTyped, UserToJSON } from "./User";

/**
 *
 * @export
 * @interface UserControllerResponse
 */
export interface UserControllerResponse {
  /**
   *
   * @type {User}
   * @memberof UserControllerResponse
   */
  data?: User;
  /**
   *
   * @type {ErrorResponse}
   * @memberof UserControllerResponse
   */
  error?: ErrorResponse;
}

export function UserControllerResponseFromJSON(json: any): UserControllerResponse {
  return UserControllerResponseFromJSONTyped(json, false);
}

export function UserControllerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : UserFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function UserControllerResponseToJSON(value?: UserControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: UserToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
